/**
 * A global namespace for `scroll` event.
 */
const scrollEvent = 'scroll';
export default scrollEvent;
